// Treasure Collect – plays the homepage entrances (value icons drawing themselves, universe cards dealing their displays)
// the first time each block scrolls into view. Blocks already on screen at load are simply shown, never hidden first.
(() => {
  if (window.tcInview) return;
  window.tcInview = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const show = (el) => el.classList.add('is-in');
  const io = 'IntersectionObserver' in window && !reduce
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' })
    : null;
  const scan = (scope) => scope.querySelectorAll('[data-tc-inview]:not(.is-in)').forEach((el) => {
    const r = el.getBoundingClientRect();
    if (!io || (r.top < window.innerHeight * 0.92 && r.bottom > 0)) { show(el); return; }
    el.classList.add('is-armed');
    io.observe(el);
  });
  scan(document);
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();
